export default __webpack_public_path__ + "static/media/mastercard.f5a1ebc3.webp";